module.exports = __webpack_public_path__ + "img/Logo-Nikol.f3715ecc.png";